module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('partial-header', {
    ref: "header",
    on: {
      "toggle-drawer": _vm.toggleDrawer
    }
  }), _vm._v(" "), _c('partial-drawer-navigation', {
    class: {
      'sidenav-open': _vm.showDrawer
    },
    on: {
      "close-drawer": function($event) {
        _vm.showDrawer = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [(_vm.ready && !_vm.header) ? [_c('router-view')] : [_c('transition', {
    attrs: {
      "tag": "section",
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)]], 2), _vm._v(" "), _c('cookies-modal'), _vm._v(" "), (_vm.ready && _vm.footer) ? _c('partial-footer', {}) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13a4083c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 279
// module chunks = 18